import React, { useCallback, useState } from 'react';
import Image from 'react-bootstrap/esm/Image';
import Cropper from 'react-easy-crop';
import '../image-styles.css';

export default function EasyCropImage({
  image: cropImage,
  setCroppedAreaPixels,
  croppedImage,
}) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  return (
    <div>
      <div
        style={{ minHeight: '400px', maxHeight: '400px' }}
        className="crop-container"
      >
        {!croppedImage ? (
          <Cropper
            image={cropImage}
            crop={crop}
            zoom={zoom}
            aspect={4 / 4}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
          />
        ) : (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Image
              fluid
              rounded
              src={croppedImage}
              alt={'Yok'}
              style={{ minHeight: '400px', maxHeight: '400px' }}
            ></Image>
          </div>
        )}
      </div>

      {!croppedImage && (
        <div className="controls">
          <input
            type="range"
            value={zoom}
            min={1}
            max={3}
            step={0.1}
            aria-labelledby="Zoom"
            onChange={(e) => {
              setZoom(e.target.value);
            }}
            className="zoom-range"
          />
        </div>
      )}
    </div>
  );
}
